import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { AssistiveTechnologyOnly } from '../../../styles/AssistiveTechnologyOnly';
import { HORIZONTAL_DISTANCE_NAV_ITEMS_VIEWPORT, MAX_MOBILE_WIDTH_IN_PX, } from '../constants';
import { useIsMobileNavigation } from '../hooks/useIsMobileNavigation';
const DesktopList = styled.ul `
  display: flex;
  flex-wrap: nowrap;
  font-size: 0.8125rem;
  height: 100%;
  list-style-type: none;
`;
const MobileList = styled.ul `
  padding: 0 ${HORIZONTAL_DISTANCE_NAV_ITEMS_VIEWPORT};
  text-align: center;
  display: grid;
  grid-gap: 2rem;

  @supports (grid-gap: clamp(1.5rem, 5vh, 2.5rem)) {
    grid-gap: clamp(1.5rem, 5vh, 2.5rem);
  }
`;
const FullHeightNav = styled.nav `
  height: 100%;
  width: 100%;

  @media screen and (max-width: ${MAX_MOBILE_WIDTH_IN_PX}) {
    height: auto;
  }
`;
const VisuallyHiddenLabel = styled.h2 `
  ${AssistiveTechnologyOnly}
`;
const ID_SECONDARY_NAVIGATION_LABEL = 'secondary-navigation-label';
export const SecondaryNavigation = ({ children, }) => {
    const { t } = useTranslation('MainNavigation');
    const isMobile = useIsMobileNavigation();
    return (React.createElement(FullHeightNav, { "aria-labelledby": ID_SECONDARY_NAVIGATION_LABEL, isMobile: isMobile },
        React.createElement(VisuallyHiddenLabel, { id: ID_SECONDARY_NAVIGATION_LABEL }, t('SecondaryNavigationLabel')),
        isMobile ? (React.createElement(MobileList, null, children)) : (React.createElement(DesktopList, null, children))));
};
